import React from 'react';
import {FormattedMessage} from 'react-intl';
import PerformanceSubnav from 'containers/performance/components/PerformanceSubnav';
import {Avatar} from 'components';
import AwaitingTag from '../../AwaitingTag';
import {withState} from 'shared/core';
import {fullName, dateFormatter} from 'shared/tools';
import {Link} from 'react-router-dom';
import _ from 'lodash';
import EmptyState from './EmptyState';
import MyCheckInsContainerState from './state/MyCheckInsContainerState';

const CheckInLink = ({status, lastCheckinId, cycle, reviewer}) => {
  if (status === 'awaiting') {
    return <UpdateCheckInLink lastCheckinId={lastCheckinId}/>;
  } else {
    return <CreateCheckInLink cycle={cycle} reviewer={reviewer}/>;
  }
};

const UpdateCheckInLink = ({lastCheckinId}) => {
  return (
    <a href={`/performance/checkins/${lastCheckinId}`} className='Btn Btn--primary'>
      <FormattedMessage id='performance.Update Check-In'/>
    </a>
  );
};

const CreateCheckInLink = ({cycle, reviewer}) => {
  return (
    <a href={`/performance/checkins/cycle/${cycle.id}/reviewer/${reviewer.id}`} className='Btn Btn--primary'>
      <FormattedMessage id='performance.Check-In'/>
    </a>
  );
};

const CheckinTag = ({firstName, status, percentage}) => {
  if (status === 'awaiting')
    return null;

  return (
    <div className='inline-block'>
      {percentage >= 100 &&
        <div className='MessageTag MessageTag--tangerine'><FormattedMessage id="performance.DUE_FOR_CHECKIN_WITH" values={{name: firstName}} /></div>}
      {(percentage < 100 && percentage >= 80) &&
        <div className='MessageTag MessageTag--ufo'><FormattedMessage id="performance.GREAT_TIME_TO_CHECKIN_WITH" values={{name: firstName}} /></div>}
    </div>
  );
};

const CheckinRow = ({reviewer, cycle, firstName, lastName, jobTitle, status, lastCheckinId, daysSinceLastCheckin, totalDays, border}) => {
  return (
    <div className='px3 bg-white rounded'>
      <div className='clearfix px2'>
        <div className={`col col-12 py3 ${border ? 'border-bottom' : ''}`}>
          <div className='clearfix table mxn1'>
            <div className='col-6 table-cell align-middle pr1'>
              <div className='table-cell align-middle pr1'>
                <Avatar employee={reviewer} size='md' className='left'/>
              </div>
              <div className='table-cell align-middle pl1'>
                <div className='h3 medium'>{fullName({firstName, lastName})}</div>
                <div className='h5'>
                  <FormattedMessage id='performance.JOB_TITLE_CYCLE_NAME' values={{
                    jobTitle: jobTitle,
                    cycleName: cycle.name
                  }}/>
                </div>
              </div>
            </div>
            <div className='col-6 table-cell align-middle pl1 right-align'>
              <CheckinTag firstName={firstName} status={status} percentage={daysSinceLastCheckin * 100 / totalDays}/>
              <CheckInLink lastCheckinId={lastCheckinId} cycle={cycle} status={status} reviewer={reviewer}/>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const dateStatus = (createdAt, completedAt) => {
  if (completedAt) {
    return <FormattedMessage id="performance.COMPLETED_DATE" values={{date: dateFormatter(completedAt)}} />;
  } else {
    return <FormattedMessage id="performance.SUBMITTED_DATE" values={{date: dateFormatter(createdAt)}} />;
  }
};

const CheckinCompletedRow = ({id, reviewer, createdAt, completedAt}) => {
  return (
    <Link to={`/checkins/${id}`}>
      <div className='col col-12 border-bottom py2'>
        <div className='clearfix table'>
          <div className='col-6 md-col-5 table-cell align-middle'>
            <div className='table-cell align-middle h5 waterloo'>
              <FormattedMessage id='performance.with'/>
            </div>
            <div className='table-cell align-middle px2'>
              <Avatar employee={reviewer} size='sm' />
            </div>
            <div className='table-cell align-middle h4 tuatara medium'>{fullName(reviewer)}</div>
          </div>
          <div className='col-6 md-col-7 table-cell align-middle'>
            <div className='table-cell align-middle jumbo pr2'>
              {dateStatus(createdAt, completedAt)}
            </div>
            <div className='table-cell align-middle pl2'>
              <AwaitingTag status={completedAt ? null : 'awaiting'} />
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
};

const CheckinList = ({checkins}) => {
  if (_.isEmpty(checkins)) return null;

  return (
    <div className='clearfix mb3 box-shadow-1 rounded bg-white'>
      <div className='col col-12 h2 p3 border-bottom'>
        <div className='px2'>
          <FormattedMessage id="performance.Previous Check-Ins"/>
        </div>
      </div>
      <div className='col col-12 px3'>
        <div className='clearfix px2 pb3'>
          {checkins.map((checkin, index) => <CheckinCompletedRow {...checkin} key={checkin.id} />)}
        </div>
      </div>
    </div>
  );
};

const MyCheckInsContainer = ({uiState}) => {
  const {pairs, checkins, isLeader} = uiState;

  return (
    <div>
      <PerformanceSubnav isLeader={isLeader}/>
      <div className="Container">
        {!!pairs.length && <div className='clearfix my3 box-shadow-1 rounded'>
          {pairs.map((pair, index) =>
            <CheckinRow {...pair.reviewer} {...pair} key={pair.id} border={pairs.length > index + 1} />
          )}
        </div>}
        {!_.isEmpty(checkins) && <CheckinList checkins={checkins} />}
        {_.isEmpty(checkins) && _.isEmpty(pairs) && <EmptyState/>}
      </div>
    </div>
  );
};



export default withState(MyCheckInsContainer, MyCheckInsContainerState);
